import { Component, input, PipeTransform } from '@angular/core';

export interface DetailItem {
  label: string; // The label to display
  value: unknown; // The value to display (string, number, date...)
  pipe?: PipeTransform; // Optional: A pipe to apply (date, filesize...)
}

@Component({
  selector: 'aura-details-panel',
  templateUrl: './details-panel.component.html',
})
export class DetailsPanelAuraComponent {
  readonly title = input<string>('');
  readonly sections = input<DetailItem[][]>([]);
}
